import i, { css as a } from "styled-components";
import { Icon as d } from "../Icon/Icon.es.js";
const p = i.div.withConfig({
  displayName: "StepBarLine",
  componentId: "sc-1fcg1xm-0"
})(["background-color:var(--color-border-strong);display:flex;height:2px;justify-content:space-between;left:30px;margin-top:10px;position:absolute;top:4px;transform:translateY(-50%);", ""], ({
  leftEdgeStepWidth: t,
  rightEdgeStepWidth: e
}) => a(["left:", "px;width:calc(100% - ", "px);"], t / 2 + 15, (t + e) / 2)), x = i.div.withConfig({
  displayName: "StepBarLineProgress",
  componentId: "sc-1fcg1xm-1"
})(["background-color:var(--color-accent-primary-default);height:100%;", ""], ({
  progress: t
}) => a(["width:", "%;"], t)), c = i.div.withConfig({
  displayName: "StepBarStepBox",
  componentId: "sc-1fcg1xm-2"
})(["align-items:center;background-color:var(--color-bg-body);border:2px solid var(--color-border-strong);border-radius:50%;color:var(--color-fg-weakest3);display:flex;height:30px;justify-content:center;margin-bottom:5px;max-width:30px;min-width:30px;z-index:1;"]), l = i.div.withConfig({
  displayName: "StepBarStepBody",
  componentId: "sc-1fcg1xm-3"
})([""]), g = i.div.withConfig({
  displayName: "StepBarStepLabel",
  componentId: "sc-1fcg1xm-4"
})([""]), h = i.div.withConfig({
  displayName: "StepBarStepDescription",
  componentId: "sc-1fcg1xm-5"
})([""]), r = i.div.withConfig({
  displayName: "StepBarSteps",
  componentId: "sc-1fcg1xm-6"
})(["align-items:flex-start;display:flex;width:100%;"]), n = i.div.withConfig({
  displayName: "StepBarStep",
  componentId: "sc-1fcg1xm-7"
})(["display:flex;flex-direction:column;max-width:calc(100% / 3);min-width:max-content;width:calc(100% / 3);", " ", ""], ({
  isActive: t,
  isCompleted: e
}) => {
  var o, s;
  return (t || e) && a(["", "{border:2px solid var(--color-accent-primary-default);color:var(--color-accent-primary-default);}", "{color:var(--color-accent-primary-default);}", "{font-weight:700;}"], c, (s = (o = d) == null ? void 0 : o.S) == null ? void 0 : s.Icon, l);
}, ({
  isCompleted: t
}) => {
  var e, o;
  return t && a(["", "{background-color:var(--color-accent-primary-default);color:var(--color-fg-inverse-default);", "{color:var(--color-fg-inverse-default);}}"], c, (o = (e = d) == null ? void 0 : e.S) == null ? void 0 : o.Icon);
}), w = i.div.withConfig({
  displayName: "StepBar",
  componentId: "sc-1fcg1xm-8"
})(["align-items:center;display:flex;gap:16px;justify-content:space-between;position:relative;", ""], ({
  direction: t,
  labelPosition: e,
  stepsLength: o
}) => {
  if (t === "vertical")
    return a(["", "{align-items:flex-start;flex-direction:column;height:100%;width:fit-content;gap:32px;min-height:", "px;justify-content:space-between;}", "{height:calc(100% - 80px);left:15px;top:calc(100% - calc(100% - 28px));transform:translateX(-50%);width:2px;}", "{align-items:flex-start;display:flex;flex-direction:row;gap:16px;max-width:100%;width:max-content;}", ""], r, o * 120, p, n, e === "start" && a(["justify-content:flex-end;", "{align-items:flex-start;}", "{justify-content:flex-end;}", "{order:1;text-align:right;}", "{order:2;}", "{left:calc(100% - 15px);}"], r, n, l, c, p));
  if (t === "horizontal")
    return a(["", "{justify-content:space-between;min-width:", "px;}", "{max-width:calc(100% / ", ");width:fit-content;align-items:center;text-align:center;}", " ", ":not(:last-child),", " ", ":not(:first-child){align-items:center;}", ""], r, o * 134, n, o, r, n, r, n, e === "start" && a(["", "{order:1;}", "{order:2;}", "{align-items:flex-end;}", "{top:calc(100% - 30px);}"], l, c, r, p));
});
export {
  w as StepBar,
  p as StepBarLine,
  x as StepBarLineProgress,
  n as StepBarStep,
  l as StepBarStepBody,
  c as StepBarStepBox,
  h as StepBarStepDescription,
  g as StepBarStepLabel,
  r as StepBarSteps
};
//# sourceMappingURL=style.es.js.map
